<h1
  class="page-title"
  *ngIf="title"
  baseTruncate
>
  {{ title | translate: titleTranslateParams }}
</h1>
